import React from 'react';
import { Breadcrumb, Container } from 'react-bootstrap';
import { useRouter } from 'next/router';
import { DateTime } from 'luxon';
import { HostDashboardGroupBookingsDocument } from '@website/types/graphqlOperations';
import { useQuery } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import GroupBookingsList from '@website/components/hosts/dashboard/groupBookings/GroupBookingsList';
import Link from 'next/link';

/**
 *
 * React Component responsible for containing and building the Group Detail View
 *
 */
export function GroupDetail({ query }) {
  const { groupID } = query;

  const {
    data: { group } = {},
    loading,
    error,
  } = useQuery(HostDashboardGroupBookingsDocument, {
    variables: { id: groupID },
    fetchPolicy: 'cache-and-network',
  });

  if (error) return <ErrorPage error={error} />;
  if (loading) return <LoadingPage />;

  return (
    <>
      <Container className="pt-3">
        <Breadcrumb className="py-3">
          <Link
            href={`/hosts/dashboard/${query.hostURL}`}
            passHref
            legacyBehavior
          >
            <Breadcrumb.Item href="">Host Dashboard</Breadcrumb.Item>
          </Link>
          <Link
            href={`/hosts/dashboard/${query.hostURL}/bookings`}
            passHref
            legacyBehavior
          >
            <Breadcrumb.Item>Bookings</Breadcrumb.Item>
          </Link>
          <Breadcrumb.Item active>
            {group.trip.title} -{' '}
            {DateTime.fromISO(group.start.utc, {
              zone: group.start.zone,
            }).toLocaleString(DateTime.DATETIME_MED)}
          </Breadcrumb.Item>
        </Breadcrumb>
        <h1>{group.trip.title}</h1>
        <h3>
          {DateTime.fromISO(group.start.utc, {
            zone: group.start.zone,
          }).toLocaleString(DateTime.DATETIME_MED)}
        </h3>
        <GroupBookingsList group={group} />
      </Container>
    </>
  );
}

export default function GroupDetailPage() {
  const { query } = useRouter();
  return (
    <RequiresAuth>
      <GroupDetail query={query} />
    </RequiresAuth>
  );
}
